var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 26,
    viewBox: "0 0 68 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.386528 6.16504H3.35532L7.56603 15.8591L11.7767 6.16504H14.7455L8.56546 20.4031H6.56601L0.385925 6.16504H0.386528Z",
    fill: "#0F1D2B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3666 8.74032H30.9885V6.16504H43.4792L35.5747 17.8278H42.9546V20.4025H30.4867L38.3672 8.73972L38.3666 8.74032Z",
    fill: "#0F1D2B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6165 6.16504H61.9888H59.5356H59.1108V20.4031H61.9888V8.74032H66.4961L67.6165 6.16504Z",
    fill: "#0F1D2B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6114 25.9905H21.6639L30.2923 6.16504H27.2627L23.1736 15.5564L18.7198 6.16504H15.63L21.7192 18.9187L18.6114 25.9905Z",
    fill: "#0F1D2B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.5048 15.6639L54.4663 15.747C53.7406 17.3024 52.4145 18.1243 50.6316 18.1243C48.09 18.1243 46.507 16.1387 46.1899 14.0959H57.6072L57.6084 13.8636C57.621 11.5116 56.8202 9.40383 55.3526 7.92845C54.0391 6.60772 52.3158 5.88086 50.4993 5.88086C46.5936 5.88086 43.4166 9.20045 43.4166 13.2806C43.4166 17.3607 46.5858 20.628 50.6316 20.628C53.4837 20.628 55.7004 19.3018 56.8611 16.9492L54.5048 15.6645V15.6639ZM50.4999 8.38394C52.3405 8.38394 53.9819 9.69986 54.5812 11.6193H46.3668C46.8993 9.96702 48.4312 8.38394 50.4999 8.38394Z",
    fill: "#0F1D2B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo);
export default __webpack_public_path__ + "static/media/header-logo.4647253c12fea4c904cf27f20e94de56.svg";
export { ForwardRef as ReactComponent };